import { SvgIcon, SvgIconProps } from '@mui/material';
import './ccf-forward-audio-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfForwardAudioIconProps extends SvgIconProps  {}

/**
 * Component used to to show forard audio icon in voicemail
 * @param props -CcfForwardAudioIconProps
 * @example
 * @returns
 */
export function CcfForwardAudioIcon(props: CcfForwardAudioIconProps) {
  return (
    <SvgIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M10.2556 8.3819e-06C13.2 0.0777862 15.8111 1.42223 17.5889 3.51112L19.0556 2.05556C19.1333 1.97779 19.2333 1.92223 19.3444 1.91112C19.4556 1.8889 19.5667 1.91112 19.6667 1.94445C19.7667 1.9889 19.8556 2.05556 19.9111 2.15556C19.9667 2.24445 20 2.34445 20 2.45556V7.22223C20 7.53334 19.7556 7.77779 19.4444 7.77779H14.6778C14.1778 7.77779 13.9333 7.17779 14.2889 6.83334L16.0111 5.10001C14.5778 3.35556 12.4222 2.22223 10 2.22223C5.2 2.22223 1.4 6.60001 2.37778 11.5667C2.97778 14.6445 5.5 17.1 8.57778 17.6445C12.8 18.4 16.5556 15.7111 17.5222 11.9111C17.6556 11.4445 18.1 11.1111 18.5889 11.1111C19.3111 11.1111 19.8556 11.7889 19.6778 12.4778C18.5778 16.8 14.6667 20 10 20C4.37778 20 -0.155556 15.3667 0 9.71112C0.155554 4.2889 4.83333 -0.133325 10.2556 8.3819e-06Z"
        fill="#007AB8"
      />
    </SvgIcon>
  );
}

export default CcfForwardAudioIcon;
